export default "__VITE_ASSET__CqTtKpPX__"